// src/components/AdminSignup.js (Renamed for clarity, assuming original was a placeholder name)

import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminSignup = () => {
      const { isMainAdmin } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    gender: '',
    numberCode: '+92',
    // 💡 UPDATED: Set 'admin' as the default but allow selection
    role: 'admin', 
    number: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const { email, password, ...profileData } = formData;
    // 💡 NOTE: profileData now includes 'role' from formData

    if (!email || !password || !profileData.firstName || !profileData.lastName || !profileData.role) {
      return setError("Please fill out all required fields.");
    }

    try {
      setLoading(true);
      // 'profileData' now correctly passes the selected 'role' to the signup function
      await signup(email, password, profileData); 
      alert(`Signup successful! ${profileData.role} profile created in Firestore.`);
      navigate('/'); 
    } catch (err) {
      setError('Failed to create an account. ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Restrict access
  if (!isMainAdmin) {
    return (
      <div className="text-center mt-20 text-red-600 font-semibold">
        Access denied. Only Main Admins can create admin accounts.
      </div>
    );
  }

  // 🔹 UI
  return (
    <div className="min-h-screen flex items-center justify-center bg-offwhite py-24">
      <div className="w-full max-w-xl bg-beige shadow-xl rounded-2xl border border-tan p-10 my-4">
        
        {/* Title */}
        <h2 className="text-3xl font-bold text-primary mb-3 text-center">
          Create Admin Account
        </h2>
        <p className="text-center text-darktaupe mb-6">
          Register a new Administrator or Main Administrator
        </p>

        {/* Error */}
        {error && (
          <div className="bg-redburnt text-offwhite p-3 mb-6 rounded-lg border border-darktaupe shadow">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Name Fields */}
          <div className="grid grid-cols-2 gap-4">
            <input
              name="firstName"
              type="text"
              placeholder="First Name"
              required
              onChange={handleChange}
              className="p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
              focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
              value={formData.firstName}
            />
            <input
              name="lastName"
              type="text"
              placeholder="Last Name"
              required
              onChange={handleChange}
              className="p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
              focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
              value={formData.lastName}
            />
          </div>

          {/* Gender */}
          <select
            name="gender"
            required
            onChange={handleChange}
            className="w-full p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
            focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
            value={formData.gender}
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>

          {/* 🚀 NEW: Role Selection Field */}
          <select
            name="role"
            required
            onChange={handleChange}
            className="w-full p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
            focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
            value={formData.role}
          >
            <option value="admin">Admin</option>
            <option value="main-admin">Main Admin</option>
          </select>
          {/* 🚀 END NEW */}

          {/* Phone */}
          <div className="flex space-x-2">
            <input
              name="numberCode"
              type="text"
              placeholder="+92"
              value={formData.numberCode}
              onChange={handleChange}
              className="w-1/4 p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
              focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
            />
            <input
              name="number"
              type="tel"
              placeholder="Phone Number"
              onChange={handleChange}
              className="w-3/4 p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
              focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
              value={formData.number}
            />
          </div>

          {/* Email */}
          <input
            name="email"
            type="email"
            placeholder="Email"
            required
            onChange={handleChange}
            className="w-full p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
            focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
            value={formData.email}
          />

          {/* Password */}
          <input
            name="password"
            type="password"
            placeholder="Password (min 6 chars)"
            required
            onChange={handleChange}
            className="w-full p-3 rounded-xl border border-taupe bg-offwhite text-charcoal 
            focus:outline-none focus:ring-2 focus:ring-primary shadow-sm"
            value={formData.password}
          />

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-offwhite py-3 rounded-xl font-semibold shadow-md 
            hover:bg-darktaupe transition duration-300 disabled:opacity-50"
          >
            {loading ? 'Registering...' : 'Create Account'}
          </button>
        </form>

        {/* Extra Note */}
        <p className="text-center text-sm text-darktaupe mt-6">
          Already have an account?{" "}
          <span 
            className="text-primary font-semibold cursor-pointer hover:underline"
            onClick={() => navigate('/login')}
          >
            Log In
          </span>
        </p>
      </div>
    </div>
  );
};

export default AdminSignup;